import { FileText } from "lucide-react";
import { Container, IconContainer, Mensagem } from "./styles";

export default function AbaPrincipalVazio() {
    return (
        <Container>
            <IconContainer>
                <FileText size={48} />
            </IconContainer>
            <Mensagem>Nenhuma informação disponível.</Mensagem>
        </Container>
    );
}

